import React, { useEffect, useState, useRef } from 'react';
import { useParams, useHistory } from 'react-router-dom';

import { Page, NotifyModal, SearchBar, BootstrapMultiSelect } from 'components';
import { Forms, Equipments, Cooperatives } from './components';
import AddAlarm from '../../components/AddAlarm/AddAlarm';
import AddRotation from '../../components/AddRotation/AddRotation';

import FileUpload from '../../components/FileUpload/FileUpload'
import Header from '../../components/Header/Header';
import Reload from 'components/Reload/Reload';

import { updateEquipmentFields } from 'api/equipmentsService';

import {
  Tab,
  Col,
  Row,
  Tabs,
  Card,
  Form,
  Modal,
  Button,
  FloatingLabel,
  DropdownButton,
  Dropdown,
} from 'react-bootstrap';

import ApiMServer from 'services/ApiMServer';
import ApiGServer from 'services/ApiGServer';
import { RENTAL_PLANS } from 'constants/planOptions';
import { matchesCompanySearch } from 'utils/searchMatch';

import './CooperativesDetail.css';
import Dryers from './components/Dryers';
import DryersTable from './components/DryersTable';

const CooperativesDetail = (props) => {
  const _id = useParams().id;

  const history = useHistory();

  const data = JSON.parse(localStorage.getItem('userData'));
  if (data?.permission?.cooperatives?.read !== true) {
    window.location.replace('/home');
  }

  const idUser = data?._id;
  const email = data?.email;

  const [openDialogActivation, setOpenDialogActivation] = useState(false);
  const [showModelSelectModal, setShowModelSelectModal] = useState(false);
  const [selectedModels, setSelectedModels] = useState([]);
  const [openDialogPlanRental, setOpenDialogPlanRental] = useState(false);
  const [openDialogPlanOwner, setOpenDialogPlanOwner] = useState(false);
  const [showUnitsConfirmModal, setShowUnitsConfirmModal] = useState(false);
  const [unitsToAdd, setUnitsToAdd] = useState([]);
  const [showUnitsConflictModal, setShowUnitsConflictModal] = useState(false);
  const [unitsConflictList, setUnitsConflictList] = useState([]);
  const [addingUnits, setAddingUnits] = useState(false);

  const [daystoactivate, setDaystoactivate] = useState('');
  const [equipments, setEquipments] = useState([]);
  const [equipmentsAll, setEquipmentsAll] = useState([]);
  const [serialsnumbers, setSerialsNumbers] = useState([]);
  const [id, setId] = useState('');
  const [permission, setPermission] = useState(false);
  const [alertMessage, setAlertMessage] = useState({ "message": '', "type": '' });
  const [selectedEquipments, setSelectedEquipments] = useState([]);
  const [selectedUnits, setSelectedUnits] = useState([]);
  const [chave, setChave] = useState('equipamentos');
  const [unit, setUnit] = useState([]);
  const [unidades, setUnidades] = useState([]);
  const [rentalEquipments, setRentalEquipments] = useState([])
  const [ownerEquipments, setOwnerEquipments] = useState([])
  const [equipmentsCooperative, setEquipmentsCooperative] = useState([])

  // Estado para detecção de tema
  const [theme, setTheme] = useState(() => {
    const savedTheme = localStorage.getItem('theme');
    const bodyHasDarkClass = document.body.classList.contains('dark-theme');
    const htmlHasDarkClass = document.documentElement.classList.contains('dark-theme');

    if (savedTheme) {
      return savedTheme;
    }

    return bodyHasDarkClass || htmlHasDarkClass ? 'dark' : 'light';
  });

  const [allEmails, setAllEmails] = useState([]);

  const [unitsDetail, setUnitsDetail] = useState([]);
  const [unitsDetailAll, setUnitsDetailAll] = useState([]);

  const [searchData, setSearchData] = useState('');

  const [onlyCoopEquipments, setOnlyCoopEquipments] = useState(false);

  const handleSearchData = (e) => {
    setSearchData(e.target.value)
  };

  const [loading, setLoading] = useState(true);

  const [type, setType] = useState({ "color": "", "status": "" });
  const [modalShow, setModalShow] = useState(false);

  // Estados para o modal de confirmação de batch actions
  const [showBatchModal, setShowBatchModal] = useState(false);
  const [batchAction, setBatchAction] = useState({ field: '', value: false, label: '' });

  const handleAlertModalSuccess = (msg) => {
    setType({ "color": "#198754", "status": msg })
    setModalShow(true)
  }

  const handleAlertModalError = (msg) => {
    setType({ "color": "orange", "status": msg })
    setModalShow(true)
  }

  // Funções para o modal de confirmação de batch actions
  const handleBatchActionRequest = (field, value, label) => {
    setBatchAction({ field, value, label });
    setShowBatchModal(true);
  };

  const handleConfirmBatchAction = () => {
    setFilds(prev => ({
      ...prev,
      [batchAction.field]: batchAction.value
    }));
    setShowBatchModal(false);
  };

  const handleCancelBatchAction = () => {
    setShowBatchModal(false);
  };

  // useEffect para detectar mudanças de tema
  useEffect(() => {
    const handleThemeChange = () => {
      const bodyHasDarkClass = document.body.classList.contains('dark-theme');
      const htmlHasDarkClass = document.documentElement.classList.contains('dark-theme');
      const savedTheme = localStorage.getItem('theme');

      let detectedTheme = 'light';

      if (savedTheme) {
        detectedTheme = savedTheme;
      } else if (bodyHasDarkClass || htmlHasDarkClass) {
        detectedTheme = 'dark';
      }

      setTheme(detectedTheme);
    };

    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.attributeName === 'class') {
          handleThemeChange();
        }
      });
    });

    observer.observe(document.body, { attributes: true });
    observer.observe(document.documentElement, { attributes: true });

    return () => observer.disconnect();
  }, []);

  const [units, setUnits] = useState({
    typeCompany: false,
    crossCheck: false,
    equipments: [],
    localEquipament: [],
    units: [],
    id: '',
    name: '',
    cnpj: '',
    ncontract: '',
    fone: '',
    email: '',
    password: '',
    secretOnlyKey: '',
    accessSecretOnlyKey: '',
    dominioEmail: '',
    createdAt: '',
    updatedAt: '',
    restrictAcess: false
  });

  const [filds, setFilds] = useState({
    scan_face: null,
    full_tracking: null,
  })

  const [batchActionsLoading, setBatchActionsLoading] = useState(false);

  const [emails, setEmails] = useState([]);

  useEffect(() => {
    (async () => {
      const { data } = await ApiMServer.get('/users/manager', { headers: { id: _id } });
      setEmails(data);
    })();
  }, [_id]);

  const [checkbox, setCheckbox] = useState({
    simt: true,
    semt: true,
    bitm: true,
    cpmt: true,
    eemt: true,
    esmr: true,
    fard: true,
    cton: true,
    mufl: true,
    prar: true,
    sbag: true,
  });

  const handleChangeModeAll = (mode) => {
    let validate = window.confirm('Confirma essa ação para todos os equipamentos desta empresa?')
    if (validate) {
      let list = equipments.map(item => item.serialnumber);
      (async () => {
        await ApiGServer.post(`/equipment/updatemodegroup`, { "list": list, "mode": mode })
        getEquipments();
      })()
    }
    return;
  }

  const handleOpenUpdateActivation = () => {
    setShowModelSelectModal(true);
  };

  const handleCloseUpdateActivation = () => {
    setOpenDialogActivation(false);
  };

  const handleAddEquipments = async () => {
    if (!selectedEquipments.length) return;
    const data = await ApiMServer.post('/company/addequipment', { "_id": id, "serialnumber": selectedEquipments })

    if (data.status === 200) {
      setKey(!key);

      for (var i in selectedEquipments) {
        units.equipments.push(selectedEquipments[i]);
      }
      setEquipmentsCooperative((prev) => [
        ...new Set([...normalizeEquipmentSerials(prev), ...selectedEquipments]),
      ]);
      setSelectedEquipments([]);
      getEquipments();
      handleAlertModalSuccess("Adicionado com sucesso!");
    } else if (data.status === 202) {
      let confirm = window.confirm(`Cadastrado em ${data.data.name}, ir para a empresa?`);
      if (confirm) {
        if (data.data.typeCompany === true) {
          window.location.href = `/cooperatives/${data.data._id}`;
        } else {
          window.location.href = `/units/${data.data._id}`;
        }
      }
      return;
    } else {
      return
    }
  };

  const handleRemoveEquipments = async () => {
    if (!selectedEquipments.length) return;
    if (!window.confirm("Confirma remover?")) {
      return;
    } else {
      try {
        await ApiMServer.post('/company/rmequipment', {
          "_id": id,
          "serialnumber": selectedEquipments
        });
        setKey(!key);
        selectedEquipments.forEach((i) => {
          const index = units.equipments.indexOf(i);
          if (index > -1) {
            units.equipments.splice(index, 1);
          }
        })
        setEquipmentsCooperative((prev) =>
          normalizeEquipmentSerials(prev).filter(
            (serial) => !selectedEquipments.includes(serial)
          )
        );
        setSelectedEquipments([]);
        getEquipments();
        handleAlertModalSuccess("Removido com sucesso!");
      } catch (error) {
        handleAlertModalError('Falha ao atualizar!');
      }
    };
  };

  const handleOpenUnitsConfirmModal = () => {
    if (!selectedUnits.length) return;
    setUnitsToAdd([...selectedUnits]);
    setShowUnitsConfirmModal(true);
  };

  const handleRemoveUnitFromList = (unitName) => {
    setUnitsToAdd(prev => prev.filter(name => name !== unitName));
  };

  const normalizeLinkedCooperatives = (payload) => {
    const rawList = Array.isArray(payload)
      ? payload
      : Array.isArray(payload?.cooperatives)
        ? payload.cooperatives
        : Array.isArray(payload?.data)
          ? payload.data
          : payload && typeof payload === 'object' && (payload._id || payload.id || payload.name)
            ? [payload]
            : [];

    return rawList
      .map((item) => ({
        _id: String(item?._id || item?.id || ''),
        name: item?.name || item?.nome || String(item?._id || item?.id || ''),
      }))
      .filter((item) => Boolean(item._id || item.name));
  };

  const findUnitsAlreadyInOtherMatrix = async (unitIds, unitNames, currentCoopId) => {
    const results = await Promise.all(
      unitIds.map(async (unitId, index) => {
        if (!unitId) return null;

        try {
          const { data } = await ApiMServer.post('/company/v1/getcooperativebyunit', { unitId });
          const cooperatives = normalizeLinkedCooperatives(data);
          const otherMatrices = cooperatives.filter(
            (cooperative) => String(cooperative._id) !== String(currentCoopId)
          );

          if (otherMatrices.length === 0) return null;

          return {
            unitId,
            unitName: unitNames[index] || unitId,
            matrices: otherMatrices.map((cooperative) => cooperative.name).filter(Boolean),
          };
        } catch (error) {
          console.error(`Erro ao verificar matriz da unidade ${unitId}:`, error);
          return null;
        }
      })
    );

    return results.filter(Boolean);
  };

  const extractConflictUnitsFromApiError = (error, unitIds, unitNames) => {
    const payload = error?.response?.data;
    if (!payload || typeof payload !== 'object') return [];

    const rawConflicts =
      payload.conflicts ||
      payload.unitsAlreadyLinked ||
      payload.alreadyLinkedUnits ||
      payload.unitsInOtherCooperative ||
      payload.units ||
      [];

    if (!Array.isArray(rawConflicts) || rawConflicts.length === 0) return [];

    return rawConflicts
      .map((item) => {
        if (typeof item === 'string') {
          const byIdIndex = unitIds.findIndex((unitId) => String(unitId) === String(item));
          const byNameIndex = unitNames.findIndex((name) => name === item);
          const index = byIdIndex >= 0 ? byIdIndex : byNameIndex;
          return {
            unitId: byIdIndex >= 0 ? unitIds[byIdIndex] : item,
            unitName: index >= 0 ? unitNames[index] : item,
            matrices: [],
          };
        }

        const unitId = String(item?._id || item?.id || item?.unitId || '');
        const unitName =
          item?.name ||
          item?.nome ||
          item?.unitName ||
          unitNames[unitIds.findIndex((id) => String(id) === unitId)] ||
          unitId;

        const matrices = normalizeLinkedCooperatives(
          item?.cooperatives || item?.matrices || item?.cooperative || []
        ).map((cooperative) => cooperative.name);

        if (!unitId && !unitName) return null;

        return { unitId, unitName, matrices };
      })
      .filter(Boolean);
  };

  const handleAddUnits = async () => {
    if (!unitsToAdd.length) {
      setShowUnitsConfirmModal(false);
      return;
    }

    const idUnits = unitsToAdd.map((value) => {
      const matched = unidades.find((item) => item.name === value);
      return matched?._id;
    });

    setAddingUnits(true);
    try {
      await ApiMServer.post('/company/addunit', { id, units: idUnits });
      setKeyTwo(!keyTwo);
      for (const unitName of unitsToAdd) {
        units.units.push(unitName);
      }
      setSelectedUnits([]);
      setUnitsToAdd([]);
      setShowUnitsConfirmModal(false);
      handleCompanyDetail();
      handleAlertModalSuccess("Adicionado com sucesso!");
    } catch (error) {
      console.log(error);

      let conflicts = extractConflictUnitsFromApiError(error, idUnits, unitsToAdd);

      if (conflicts.length === 0) {
        conflicts = await findUnitsAlreadyInOtherMatrix(idUnits, unitsToAdd, id || _id);
      }

      if (conflicts.length > 0) {
        setUnitsConflictList(conflicts);
        setShowUnitsConfirmModal(false);
        setShowUnitsConflictModal(true);
      } else {
        const apiMessage =
          error?.response?.data?.message ||
          error?.response?.data?.status ||
          error?.response?.data?.error;
        handleAlertModalError(
          typeof apiMessage === 'string' && apiMessage.trim()
            ? apiMessage
            : 'Falha ao adicionar unidades!'
        );
      }
    } finally {
      setAddingUnits(false);
    }
  };

  const handleRemoveUnits = async () => {
    if (!selectedUnits.length) return;
    if (window.confirm("Confirma remover?")) {
      var idUnits = [];
      for (let i = 0; i < selectedUnits.length; i++) {
        var value = selectedUnits[i];
        var j = unidades.filter((item) => item.name === value).map((i) => {
          return i._id;
        })
        idUnits.push(j[0]);
      }
      try {
        await ApiMServer.post('/company/rmunit', {
          "id": id,
          "units": idUnits
        })
        setKeyTwo(!keyTwo);
        selectedUnits.forEach((i) => {
          const index = units.units.indexOf(i);
          if (index > -1) {
            units.units.splice(index, 1);
          }
        })

        handleCompanyDetail();
        handleAlertModalSuccess("Removido com sucesso!");

      } catch (error) {
        handleAlertModalError('Falha ao atualizar!')
      }
    };
  };

  const handleDaysChange = (event, field, value) => {
    event.persist && event.persist();
    setDaystoactivate(value);
  };

  useEffect(() => {
    const { id } = props.match.params;
    setId(id);
  }, [props]);

  const handleGetCompany = async (units) => {
    let nameUnits = [];
    try {
      const { data } = await ApiMServer.get(`/company/get`);
      setUnidades(data);
      nameUnits = data
        .filter(unit =>
          unit.name &&
          !unit.typeCompany &&
          !units.includes(unit._id)
        )
        .map(item => item.name);

      setUnit(nameUnits);
    } catch (error) {
      console.error(error);
      setUnit([]);
    }
  };

  const normalizeEquipmentSerials = (list) => {
    if (!Array.isArray(list)) return [];

    return list
      .map((item) => {
        if (typeof item === 'string') return item.trim();
        if (item && typeof item === 'object') {
          return String(
            item.serialnumber ||
            item.serial ||
            item.id ||
            ''
          ).trim();
        }
        return '';
      })
      .filter(Boolean);
  };

  const handleCompanyDetail = async () => {
    try {
      let { data: unit } = await ApiMServer.post(`/company/v1/getcooperativedetail`, { id: _id });
      setUnits(unit);

      const [detailResponse, unitsResponse] = await Promise.all([
        ApiMServer.post(`/company/detail`, { id: _id }),
        unit?.units?.length > 0
          ? ApiMServer.post('/company/get/units', { arrayIds: unit.units })
          : Promise.resolve({ data: [] }),
      ]);

      const linkedUnits = Array.isArray(unitsResponse?.data) ? unitsResponse.data : [];
      setUnitsDetail(linkedUnits);
      setUnitsDetailAll(linkedUnits);

      const unitSerials = linkedUnits.flatMap((linkedUnit) =>
        normalizeEquipmentSerials(linkedUnit?.equipments)
      );
      const unitSerialsSet = new Set(unitSerials);

      // Equipamentos da matriz (company/detail). Se a API devolver a lista agregada,
      // remove os seriais das unidades para ficar só a matriz.
      let matrixSerials = normalizeEquipmentSerials(
        detailResponse?.data?.equipments ??
        detailResponse?.data?.localEquipament ??
        detailResponse?.data?.data?.equipments ??
        unit?.localEquipament
      );

      if (matrixSerials.length === 0) {
        // Fallback: o que está no detalhe da cooperativa e não pertence às unidades
        matrixSerials = normalizeEquipmentSerials(unit?.equipments).filter(
          (serial) => !unitSerialsSet.has(serial)
        );
      } else if (unitSerialsSet.size > 0) {
        const onlyMatrix = matrixSerials.filter((serial) => !unitSerialsSet.has(serial));
        // Se a lista da matriz continha equipamentos de unidade, usa só a diferença
        if (onlyMatrix.length !== matrixSerials.length) {
          matrixSerials = onlyMatrix;
        }
      }

      setEquipmentsCooperative(matrixSerials);

      // Tudo = matriz + unidades
      const allSerials = [...new Set([
        ...matrixSerials,
        ...unitSerials,
        ...normalizeEquipmentSerials(unit?.equipments),
      ])];

      if (allSerials.length > 0) {
        const { data: equipmentData } = await ApiGServer.post(`/equipment/filter`, {
          filter: allSerials,
        });
        setEquipments(equipmentData);
        setEquipmentsAll(equipmentData);
        handlefilterEquipments(equipmentData);
      } else {
        setEquipments([]);
        setEquipmentsAll([]);
        handlefilterEquipments([]);
      }

      handleGetCompany(unit?.units || []);
      setLoading(false);
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  const handlefilterEquipments = (equipamentos) => {
    const rentalEquipments = equipamentos
      .filter(equip => equip.mode === "RENTAL")
      .map(equip => equip.serialnumber)

    setRentalEquipments(rentalEquipments)

    const ownerEquipments = equipamentos
      .filter(equip => equip.mode === "OWNER")
      .map(equip => equip.serialnumber)
    setOwnerEquipments(ownerEquipments)
  }


  const [planRental, setPlanRental] = useState("");
  const handlePlanChangeRental = (plan) => {
    setOpenDialogPlanRental(true);
    setPlanRental(plan);
  };

  const handleUpdatePlanChangeRental = () => {
    handlePlan(planRental, rentalEquipments);
  };

  const [planOwner, setPlanOwner] = useState("");
  const handlePlanChangeOwner = (plan) => {
    setOpenDialogPlanOwner(true);
    setPlanOwner(plan);
  };

  const handleUpdatePlanChangeOwner = () => {
    handlePlan(planOwner, ownerEquipments);
  };

  const handleCloseDialogPlan = () => {
    setOpenDialogPlanRental(false);
    setOpenDialogPlanOwner(false);
  };

  const handlePlan = async (newPlan, serials) => {
    if (planRental || planOwner) {
      setEquipments((prevEquipments) => {
        const updatedEquipments = prevEquipments.map((equipment) => {
          if (serials.includes(equipment.serialnumber)) {
            return { ...equipment, plan: newPlan };
          }
          return equipment;
        });
        return updatedEquipments;
      });

      try {
        await ApiGServer.post(`/equipment/updateplan`, { filter: serials, plan: newPlan });
        handleAlertModalSuccess("Atualizado com sucesso!");
        handleCloseDialogPlan();
      } catch (error) {
        handleAlertModalError('Falha ao atualizar!');
        handleCloseDialogPlan();
      }
    } else {
      return
    }
  };

  useEffect(() => {
    const { permission } = JSON.parse(localStorage.getItem('userData'));
    setPermission(permission?.cooperatives?.write);
    handleCompanyDetail();
  }, []);

  const getEquipments = () => {
    (async () => {
      try {
        const matrixSerials = normalizeEquipmentSerials(equipmentsCooperative);
        const unitSerials = (unitsDetailAll || []).flatMap((linkedUnit) =>
          normalizeEquipmentSerials(linkedUnit?.equipments)
        );
        const allSerials = [...new Set([
          ...matrixSerials,
          ...unitSerials,
          ...normalizeEquipmentSerials(units.equipments),
        ])];

        if (!allSerials.length) {
          setEquipments([]);
          setEquipmentsAll([]);
          handlefilterEquipments([]);
          return;
        }

        const response = await ApiGServer.post(`/equipment/filter`, { filter: allSerials });
        setEquipments(response.data);
        setEquipmentsAll(response.data);
        handlefilterEquipments(response.data);
      } catch (error) {
        console.error('Erro ao recarregar equipamentos:', error);
      }
    })();
  };

  const removeEquipment = async (serialnumber) => {
    await ApiMServer.post(`/company/rmequipment`, { "_id": id, "serialnumber": serialnumber });
    const index = units.equipments.indexOf(serialnumber);
    if (index > -1) {
      units.equipments.splice(index, 1);
    }
    getEquipments();
  };

  const removeUnit = async (_id) => {
    try {
      await ApiMServer.post(`/company/rmunit`, { "id": id, "units": _id })
      handleCompanyDetail();
      handleAlertModalSuccess("Removido com sucesso!");
    } catch (error) {
      handleAlertModalError('Falha ao atualizar!')
    }
  };

  const updateDaysActivation = async () => {
    setShowModelSelectModal(false);
    setOpenDialogActivation(false);

    if (!daystoactivate) {
      alert('O campo dias para Ativação deve ser preenchido!');
      return;
    }

    let value = parseInt(daystoactivate);
    if (isNaN(value)) {
      alert('O campo dias para Ativação deve ser preenchido com um número inteiro!');
      return;
    }

    if (value < 0 || value > 4095) {
      alert('O número de dias para Ativação deve estar entre 0 e 4095!');
      return;
    }

    // Filtra os equipamentos pelos modelos selecionados
    const serialsToUpdate = equipments
      .filter(eq => selectedModels.includes(eq.serialnumber.split('-')[0]))
      .map(eq => eq.serialnumber);

    if (serialsToUpdate.length === 0) {
      alert('Selecione ao menos um modelo para aplicar a alteração!');
      return;
    }

    try {
      await ApiGServer.post('/equipment/updatedaysactivationCompany', {
        list: serialsToUpdate,
        daystoactivate: Number(daystoactivate).toString(16).toUpperCase()
      });
      getEquipments();
      handleAlertModalSuccess('Atualizado com sucesso!');
    } catch (error) {
      console.log(error.response);
      handleAlertModalError('Falha ao atualizar!')
    }
  };

  const getAllEmail = async () => {
    try {
      const { data } = await ApiMServer.get('/user/all-email');
      setAllEmails(data);
    } catch (error) {
      console.log(error);
    }
  }

  useEffect(() => {
    (async () => {
      await ApiGServer.get('/equipment/serialsnumber')
        .then((response) => {
          var data = response.data;
          data.sort(function (a, b) {
            return a.split('-')[1] - b.split('-')[1];
          }).sort();
          setSerialsNumbers(data);
        });
    })();

    // getAllEmail();

  }, []);

  const handleFieldChange = (event, field, value) => {
    setUnits((values) => ({
      ...values,
      [field]: value
    }));
  };

  const handleCheckBoxdChange = (field, value) => {
    setCheckbox((values) => ({
      ...values,
      [field]: value
    }));
  };

  const updateAddressAndLocation = (newAddress, newLat, newLng) => {
    setUnits(prevUnits => ({
      ...prevUnits,
      address: newAddress,
      location: {
        lat: String(newLat),
        lng: String(newLng)
      }
    }));
  };

  const getOnlyCooperativeEquipments = (sourceEquipments = []) => {
    const allEquipments = Array.isArray(sourceEquipments) ? sourceEquipments : [];
    const coopSet = new Set(normalizeEquipmentSerials(equipmentsCooperative));

    if (coopSet.size === 0) return [];

    return allEquipments.filter((equipment) => coopSet.has(equipment?.serialnumber));
  };

  const filterData = () => {
    // Desmarcado: matriz + unidades | Marcado: apenas matriz
    const baseList = onlyCoopEquipments
      ? getOnlyCooperativeEquipments(equipments)
      : (Array.isArray(equipments) ? equipments : []);

    var fequips = [];

    if (checkbox.simt) {
      Array.prototype.push.apply(fequips, baseList.filter(e => e.serialnumber.split("-")[0] === "SIMT"));
    }
    if (checkbox.semt) {
      Array.prototype.push.apply(fequips, baseList.filter(e => e.serialnumber.split("-")[0] === "SEMT"));
    }
    if (checkbox.bitm) {
      Array.prototype.push.apply(fequips, baseList.filter(e => e.serialnumber.split("-")[0] === "BIMT"));
    }
    if (checkbox.cpmt) {
      Array.prototype.push.apply(fequips, baseList.filter(e => e.serialnumber.split("-")[0] === "CPMT"));
    }
    if (checkbox.eemt) {
      Array.prototype.push.apply(fequips, baseList.filter(e => e.serialnumber.split("-")[0] === "EEMT"));
    }
    if (checkbox.esmr) {
      Array.prototype.push.apply(fequips, baseList.filter(e => e.serialnumber.split("-")[0] === "ESMR"));
    }
    if (checkbox.fard) {
      Array.prototype.push.apply(fequips, baseList.filter(e => e.serialnumber.split("-")[0] === "FARD"));
    }
    if (checkbox.cton) {
      Array.prototype.push.apply(fequips, baseList.filter(e => e.serialnumber.split("-")[0] === "CTON"));
    }
    if (checkbox.mufl) {
      Array.prototype.push.apply(fequips, baseList.filter(e => e.serialnumber.split("-")[0] === "MUFL"));
    }
    if (checkbox.prar) {
      Array.prototype.push.apply(fequips, baseList.filter(e => e.serialnumber.split("-")[0] === "PRAR"));
    }
    if (checkbox.sbag) {
      Array.prototype.push.apply(fequips, baseList.filter(e => e.serialnumber.split("-")[0] === "SBAG"));
    }

    return fequips;
  }

  const handleSubmit = async () => {
    let data = units;

    delete data.equipments;
    delete data.createdAt;
    delete data.updatedAt;
    delete data.__v;

    data.idUser = idUser;

    try {
      await Promise.all([
        ApiMServer.post('/company/update', data),
        ApiMServer.post('/company/creategestor', { emails, id: units._id })
      ]);

      handleAlertModalSuccess('Atualizado com sucesso!');
    } catch (error) {
      console.error('Erro ao atualizar:', error);
      handleAlertModalError('Falha ao atualizar os dados. Tente novamente.');
    }
  };

  const handleGetRepor = async () => {
    setLoading(true);
    try {
      window.open(`${process.env.REACT_APP_API_MOTOMCO}/managementReport/${_id}`)
      setLoading(false);
    } catch (error) {
      handleAlertModalError('Falha ao atualizar!');
      setLoading(false);
    }
  }

  const handleOpenCompany = async () => {
    try {
      await ApiMServer.post(`/company/addgestor`, { id: _id, emails: email });
      window.open(`${process.env.REACT_APP_SGU}`);
    } catch (error) {
      console.log(error);
    }
  }

  const [charts, setCharts] = useState(null);
  const [showAllCharts, setShowAllCharts] = useState(false);

  // Sempre que a curva mudar (upload/delete), volta para o estado colapsado
  useEffect(() => {
    setShowAllCharts(false);
  }, [charts]);

  const handleDeleteCharts = async () => {
    let confirm = window.confirm("Confirma apagar curva?")
    if (!confirm || !charts) {
      return
    }
    try {
      await ApiMServer.delete(`/api/v1/deletecharts?_id=${charts?.company_id}`);
      setCharts("")
      handleAlertModalSuccess("Apagado com sucesso!")
    } catch (error) {
      handleAlertModalError("Erro ao apagar!")
    }
  }

  const handleGetChart = async () => {
    if (!_id) return;
    try {
      let { data } = await ApiMServer.get(`/api/v1/getcharts?company_id=${_id}`);
      setCharts(data)
    } catch (error) {
      console.log("Curva personalizada não encontrada");
    }
  }

  const handleReport = () => {
    // Se não tiver equipamentos, exibe mensagem e não navega
    if (!equipments || equipments.length === 0) {
      handleAlertModalError('Não há equipamentos para gerar relatório');
      return;
    }

    // Passa os dados completos diretamente via state do history
    // Não usa mais localStorage
    history.push({
      pathname: '/relatorio',
      state: {
        equipFilter: units.equipments,
        equipmentsList: equipments,
        companyName: units.name
      }
    });
  }

  const handleSearchEquipments = () => {
    if (!searchData.trim()) {
      setEquipments(equipmentsAll);
      return;
    }

    const filteredEquipments = equipmentsAll.filter((item) =>
      item?.nameEquipament?.toLowerCase().includes(searchData.toLowerCase()) ||
      item?.serialnumber?.toLowerCase().includes(searchData.toLowerCase())
    );

    setEquipments(filteredEquipments);
  };

  const handleSearchUnits = () => {
    if (!searchData.trim()) {
      setUnitsDetail(unitsDetailAll);
      return;
    }

    const term = searchData.trim();
    setUnitsDetail(unitsDetailAll.filter((unit) => matchesCompanySearch(unit, term)));
  };

  useEffect(() => {
    handleGetChart()
  }, [])

  const [key, setKey] = useState(false);
  const [keyTwo, setKeyTwo] = useState(false);
  const [openUnits, setOpenUnits] = useState(false);

  useEffect(() => {
    if (selectedUnits.length) {
      setOpenUnits(true)
    } else {
      setOpenUnits(false)
    }
  }, [selectedUnits])

  const prevValues = useRef({
    scan_face: null,
    full_tracking: null,
  });

  useEffect(() => {
    const hasScanFaceChanged = filds.scan_face !== prevValues.current.scan_face && filds.scan_face !== null;
    const hasFullTrackingChanged = filds.full_tracking !== prevValues.current.full_tracking && filds.full_tracking !== null;

    if (hasScanFaceChanged || hasFullTrackingChanged) {
      // Atualiza os valores anteriores
      prevValues.current = {
        scan_face: filds.scan_face,
        full_tracking: filds.full_tracking,
      };

      updateEquipmentsFields(); // Chama a função apenas se algum dos dois mudou de null para um valor
    }
  }, [filds.scan_face, filds.full_tracking]);

  const updateEquipmentsFields = async () => {
    let serials = equipments.map(equip => equip.serialnumber);
    setBatchActionsLoading(true);

    const fieldsToUpdate = {};

    if (filds.scan_face !== null && filds.scan_face !== undefined) {
      fieldsToUpdate.scan_face = filds.scan_face;
    }

    if (filds.full_tracking !== null && filds.full_tracking !== undefined) {
      fieldsToUpdate.full_tracking = filds.full_tracking;
    }

    if (Object.keys(fieldsToUpdate).length === 0) {
      setBatchActionsLoading(false);
      handleAlertModalError("Nenhum campo foi selecionado para atualização!");
      return;
    }

    try {
      await updateEquipmentFields(serials, fieldsToUpdate);
      handleAlertModalSuccess(`Equipamentos atualizados com sucesso!`);

      setFilds({
        scan_face: null,
        full_tracking: null,
      });

      prevValues.current = {
        scan_face: null,
        full_tracking: null,
      };

    } catch (error) {
      handleAlertModalError("Erro ao atualizar!");
      console.error('Erro na atualização dos equipamentos:', error);
    } finally {
      setBatchActionsLoading(false);
    }
  }

  const saveSecador = async (dryerData) => {
    dryerData._id = _id;
    try {
      let { data } = await ApiMServer.post(`/company/add-dryer`, dryerData);
      setUnits(data);
      handleAlertModalSuccess("Secador adicionado com sucesso!");
    } catch (error) {
      handleAlertModalError("Erro ao atualizar!");
    }
  }

  const savePositions = async (positionsData) => {
    console.log(positionsData);
    try {
      await ApiGServer.post(`/equipment/update-equipments-list`, positionsData);
      console.log("Posições atualizadas com sucesso!");
    } catch (error) {
      console.error("Erro ao atualizar posições:", error);
    }

  }

  const removeDryer = async (dryerId) => {
    if (!dryerId) {
      handleAlertModalError("Ocorreu um erro: ID do secador ausente.");
      return;
    }

    try {
      const { data: updatedUnits } = await ApiMServer.post(`/company/rm-dryer`, { companyId: _id, dryerId });

      setUnits(updatedUnits);

      handleAlertModalSuccess("Secador removido com sucesso!");

    } catch (error) {
      const errorMessage = error.response?.data?.message || 'Falha na comunicação com o servidor. Tente novamente mais tarde.';
      handleAlertModalError(errorMessage);
    }
  };

  return (
    <Page className="p-3 cooperatives-detail" title="Cooperativas">

      <Header page={"Cooperativas"} />

      {loading && <Reload />}

      <NotifyModal
        type={type}
        show={modalShow}
        onHide={() => setModalShow(false)}
      />

      <Card className='mb-3 p-2'>
        <Row>
          <Col>

            <Button
              className='ms-2 mt-2 mb-2'
              disabled={!permission}
              variant="success"
              onClick={() => { handleOpenCompany() }}
            >
              Visualização do Cliente
            </Button>

            <Button
              className='ms-2 mt-2 mb-2'
              disabled={!permission}
              variant="success"
              onClick={() => { handleGetRepor() }}
            >
              {'Relatório Gerencial'}
            </Button>

            <Button
              className='ms-2 mt-2 mb-2'
              disabled={!permission}
              variant="success"
              onClick={() => { handleReport() }}
            >
              Relatório de Ativação
            </Button>

          </Col>
        </Row>
      </Card>

      <Forms
        alertMessage={alertMessage}
        fieldChange={handleFieldChange}
        onSubmit={handleSubmit}
        handleAlertModalError={handleAlertModalError}
        units={{
          ...units,
          // Garante que todos os campos são strings para evitar warnings de input controlado/descontrolado
          name: units.name ?? '',
          cnpj: units.cnpj ?? '',
          ncontract: units.ncontract ?? '',
          fone: units.fone ?? '',
          email: units.email ?? '',
          password: units.password ?? '',
          secretOnlyKey: units.secretOnlyKey ?? '',
          accessSecretOnlyKey: units.accessSecretOnlyKey ?? '',
          dominioEmail: units.dominioEmail ?? '',
          createdAt: units.createdAt ?? '',
          updatedAt: units.updatedAt ?? '',
          id: units.id ?? '',
        }}
        permission={permission}
        setEmails={setEmails}
        emails={emails}
        setUnits={setUnits}
        setLocation={updateAddressAndLocation}
        allEmails={allEmails}
        theme={theme}
      />


      {equipments?.some(item => equipmentsCooperative?.includes(item?.serialnumber) && item?.serialnumber?.includes("SEMT")) && (
        <AddAlarm
          units={units}
          companyId={_id}
          serialNumber={equipments.filter(item => equipmentsCooperative?.includes(item?.serialnumber))}
          permission={permission}
          theme={theme}
        />
      )}

      {equipments?.some(item => equipmentsCooperative?.includes(item?.serialnumber) && item?.serialnumber?.includes("SEMT")) && (
        <AddRotation
          units={units}
          companyId={_id}
          serialNumber={equipments.filter(item => equipmentsCooperative?.includes(item?.serialnumber))}
          permission={permission}
          theme={theme}
        />
      )}

      <Card className='mb-3'>
        <Card.Header>
          <h5 className={`mt-2 mb-2 ${theme === 'dark' ? 'text-light' : 'text-dark'}`}>Equipamentos</h5>
        </Card.Header>
        <Card.Body>
          <Row className="align-items-center mb-3">
            <div className={`batch-actions ${selectedEquipments.length > 0 ? 'has-selections' : ''}`}>
              <h6 className={`mt-1 mb-2 ${theme === 'dark' ? 'text-light' : 'text-dark'}`}>
                Ações em lote
                {selectedEquipments.length > 0 && (
                  <span className={`ms-2 badge ${theme === 'dark' ? 'bg-secondary' : 'bg-primary'}`}>
                    {selectedEquipments.length} selecionado{selectedEquipments.length !== 1 ? 's' : ''}
                  </span>
                )}
                {batchActionsLoading && (
                  <span className={`ms-2 small ${theme === 'dark' ? 'text-warning' : 'text-primary'}`}>
                    ⏳ Processando...
                  </span>
                )}
              </h6>

              <div className="mt-2 d-flex flex-wrap gap-2">
                <DropdownButton
                  id="dropdown-scan-face"
                  title="📸 Foto Facial (todos)"
                  variant={theme === 'dark' ? 'outline-light' : 'outline-primary'}
                  disabled={!permission || batchActionsLoading}
                  className={batchActionsLoading ? 'loading' : ''}
                  data-bs-toggle="tooltip"
                  data-bs-placement="top"
                  title-tooltip="Ativar/Desativar foto facial para todos os equipamentos selecionados"
                >
                  <Dropdown.Item
                    onClick={() => {
                      handleBatchActionRequest('scan_face', true, 'Ativar Foto Facial para todos os equipamentos');
                    }}
                    disabled={batchActionsLoading}
                  >
                    ✅ Ativar Foto Facial
                  </Dropdown.Item>
                  <Dropdown.Item
                    onClick={() => {
                      handleBatchActionRequest('scan_face', false, 'Desativar Foto Facial para todos os equipamentos');
                    }}
                    disabled={batchActionsLoading}
                  >
                    ❌ Desativar Foto Facial
                  </Dropdown.Item>
                </DropdownButton>

                <DropdownButton
                  id="dropdown-full-tracking"
                  title="🎯 Full Tracking (todos)"
                  variant={theme === 'dark' ? 'outline-light' : 'outline-primary'}
                  disabled={!permission || batchActionsLoading}
                  className={batchActionsLoading ? 'loading' : ''}
                  data-bs-toggle="tooltip"
                  data-bs-placement="top"
                  title-tooltip="Ativar/Desativar rastreamento completo para todos os equipamentos selecionados"
                >
                  <Dropdown.Item
                    onClick={() => {
                      handleBatchActionRequest('full_tracking', true, 'Ativar Full Tracking para todos os equipamentos');
                    }}
                    disabled={batchActionsLoading}
                  >
                    ✅ Ativar Full Tracking
                  </Dropdown.Item>
                  <Dropdown.Item
                    onClick={() => {
                      handleBatchActionRequest('full_tracking', false, 'Desativar Full Tracking para todos os equipamentos');
                    }}
                    disabled={batchActionsLoading}
                  >
                    ❌ Desativar Full Tracking
                  </Dropdown.Item>
                </DropdownButton>
              </div>
            </div>
          </Row>

          <Row className='g-2'>
            <Col md>
              <BootstrapMultiSelect
                label={"Equipamentos"}
                options={serialsnumbers}
                selectedEquipments={selectedEquipments}
                setSelectedEquipments={setSelectedEquipments}
              />

              <Button
                className='mt-2'
                disabled={!permission || !selectedEquipments.length}
                variant="success"
                onClick={handleAddEquipments}
              >
                Adicionar Equipamentos
              </Button>

              <Button
                className='mt-2 ms-2'
                disabled={!permission || !selectedEquipments.length}
                variant="outline-danger"
                onClick={handleRemoveEquipments}
              >
                Remover Equipamentos
              </Button>
            </Col>

            <Col md>
              {units && units.typeCompany ?
                <div>
                  <BootstrapMultiSelect
                    label={"Unidades"}
                    options={unit}
                    selectedEquipments={selectedUnits}
                    setSelectedEquipments={setSelectedUnits}
                  />

                  <Button
                    className='mt-2'
                    disabled={!permission || !selectedUnits.length}
                    variant="success"
                    onClick={handleOpenUnitsConfirmModal}
                  >
                    Adicionar Unidades
                  </Button>
                  <Button
                    disabled={!permission || !selectedUnits.length}
                    className='mt-2 ms-2'
                    variant="outline-danger"
                    onClick={handleRemoveUnits}
                  >
                    Remover Unidades
                  </Button>

                </div>
                : null}
            </Col>
          </Row>
        </Card.Body>
      </Card>

      {equipments?.some(item => item?.serialnumber?.includes("PRAR")) && (
        <Dryers
          onAddDryer={async (dryerData, positionsData) => {

            // Salvar secador na primeira API
            await saveSecador(dryerData);

            // Salvar posições na segunda API
            await savePositions(positionsData);
          }}
          equipments={equipments}
          permission={permission}
          theme={theme}
        />
      )}

      <Card className='mb-3'>
        <Card.Header>
          <h5 className={`mt-2 mb-2 ${theme === 'dark' ? 'text-light' : 'text-dark'}`}>Curva Personalizada</h5>
        </Card.Header>
        <Card.Body>

          {/* Type = CUSTOM, INMETRO, COMPLEMENT */}
          <FileUpload
            type={"CUSTOM"}
            company={_id}
            permission={permission}
            handleGetChart={handleGetChart}
            setAlertMessage={setAlertMessage}
            handleAlertModalError={handleAlertModalError}
            handleAlertModalSuccess={handleAlertModalSuccess}
          />

          {charts?._id ?
            <>
              <h6 className={`mt-3 mb-2 ${theme === 'dark' ? 'text-light' : 'text-dark'}`}>
                {`Curva existente: ${charts?.chartCustom[0]?.hash}`}
              </h6>
              <div className={`mt-2 ${theme === 'dark' ? 'text-light' : 'text-dark'}`}>
                {(
                  showAllCharts
                    ? (charts?.chartCustom || [])
                    : (charts?.chartCustom || []).slice(0, 5)
                ).map((item, index) => {
                  const firstName = Array.isArray(item?.nome)
                    ? item.nome?.[0]
                    : item?.nome;
                  return (
                    <div key={item._id || index} className="mb-3">
                      <div><strong>Data:</strong> {item?.data || '--'}</div>
                      <div className="mt-1"><strong>Nome:</strong> {firstName || '--'}</div>
                    </div>
                  );
                })}
                {charts?.chartCustom?.length > 5 && (
                  <Button
                    className="mb-2"
                    variant={theme === 'dark' ? 'outline-light' : 'outline-primary'}
                    size="sm"
                    onClick={() => setShowAllCharts((prev) => !prev)}
                  >
                    {showAllCharts
                      ? 'Ver menos'
                      : `Ver mais (${(charts?.chartCustom?.length || 0) - 5} restantes)`}
                  </Button>
                )}
              </div>
              <Button
                disabled={!permission}
                variant="outline-danger"
                onClick={() => {
                  handleDeleteCharts()
                }}
              >
                Apagar curva personalizada existente
              </Button>
            </>
            :
            <h6 className={`mt-3 mb-2 ${theme === 'dark' ? 'text-light' : 'text-dark'}`}>{`Nenhuma curva personalizada`}</h6>
          }
        </Card.Body>
      </Card>

      <Card className='mb-3'>
        <Card.Header>
          <h5 className={`mt-2 mb-2 ${theme === 'dark' ? 'text-light' : 'text-dark'}`}>Planos</h5>
        </Card.Header>
        <Card.Body>
          <Row className='g-2'>
            <Col md>
              {rentalEquipments.length > 0 &&
                <div>
                  <h6 className={`mt-1 mb-2 ${theme === 'dark' ? 'text-light' : 'text-dark'}`}>Locação</h6>
                  <div className="mt-2 d-flex flex-wrap gap-2">
                    {RENTAL_PLANS.map((plan) => (
                      <Button
                        key={plan.value}
                        disabled={!permission}
                        onClick={() => handlePlanChangeRental(plan.value)}
                        variant="outline-success"
                      >
                        {plan.label}
                      </Button>
                    ))}
                  </div>
                </div>
              }

              {rentalEquipments.length > 0 && ownerEquipments.length > 0 ? <hr /> : null}

              {ownerEquipments.length > 0 &&
                <div>
                  <h6 className={`mt-1 mb-2 ${theme === 'dark' ? 'text-light' : 'text-dark'}`}>Proprietário</h6>
                  <div className="mt-2">
                    <Button
                      disabled={!permission}
                      onClick={() => handlePlanChangeOwner('NORMAL')}
                      variant="outline-success"
                    >
                      NORMAL
                    </Button>
                    <Button
                      disabled={!permission}
                      onClick={() => handlePlanChangeOwner('PLUS')}
                      className="ms-2"
                      variant="outline-success"
                    >
                      PLUS
                    </Button>
                    <Button
                      disabled={!permission}
                      onClick={() => handlePlanChangeOwner('FLEX')}
                      className="ms-2"
                      variant="outline-success"
                    >
                      FLEX
                    </Button>
                    <Button
                      disabled={permission === true ? false : true}
                      onClick={() => handlePlanChangeOwner('PREMIUM')}
                      className="ms-2"
                      variant="outline-success"
                    >
                      PREMIUM
                    </Button>
                  </div>
                </div>
              }
            </Col>
          </Row>
        </Card.Body>
      </Card>

      <Card className='mb-3'>
        <Card.Header>
          <h5 className={`mt-2 mb-2 ${theme === 'dark' ? 'text-light' : 'text-dark'}`}>Alterar dias de Ativação</h5>
        </Card.Header>
        <Card.Body>
          <Row>
            <Col md>
              <FloatingLabel style={{ width: 250 }} controlId="floatingInput" label="Dias" className="mb-3">
                <Form.Control
                  type="number"
                  name="Dias"
                  placeholder="Dias"
                  value={typeof daystoactivate === 'string' ? daystoactivate : (daystoactivate !== undefined && daystoactivate !== null ? String(daystoactivate) : '')}
                  onChange={(event) =>
                    handleDaysChange(event, 'daystoactivate', event.target.value)
                  }
                  disabled={!permission}
                />
              </FloatingLabel>

              <Button
                disabled={!permission}
                onClick={() => {
                  if (!daystoactivate || String(daystoactivate).trim() === '') {
                    handleAlertModalError('O campo dias para Ativação deve ser preenchido!');
                    return;
                  }
                  setShowModelSelectModal(true);
                  setSelectedModels([]);
                }}
                variant="success"
              >
                Alterar
              </Button>
            </Col>
          </Row>

          <hr />

          <Row>
            <Col md>
              <h6 className={`mt-1 mb-2 ${theme === 'dark' ? 'text-light' : 'text-dark'}`}>Alterar modo dos equipamentos</h6>

              <Button
                disabled={!permission}
                onClick={() => handleChangeModeAll('RENTAL')}
                variant="success"
              >
                Todos para locação
              </Button>
              <Button
                disabled={!permission}
                onClick={() => handleChangeModeAll('OWNER')}
                className="ms-2"
                variant="success"
              >
                Todos para proprietário
              </Button>
              <Button
                disabled={!permission}
                onClick={() => handleChangeModeAll('ISENTKEY')}
                className="ms-2"
                variant="success"
              >
                Isenção de taxas
              </Button>
            </Col>
          </Row>
        </Card.Body>
      </Card>

      <Tabs
        className="mb-3"
        activeKey={chave}
        onSelect={(key) => setChave(key)}
      >
        <Tab eventKey="equipamentos" title="EQUIPAMENTOS">
          <>
            <SearchBar
              onSearch={handleSearchEquipments}
              onSearchData={handleSearchData}
              searchData={searchData}
            />

            <div
              style={{ width: '100%', display: 'flex', flexWrap: 'wrap', gap: '1rem' }}
              className='mt-3 mb-2'>
              {[
                { key: 'simt', label: 'SIMT' },
                { key: 'semt', label: 'SEMT' },
                { key: 'bitm', label: 'BIMT' },
                { key: 'eemt', label: 'EEMT' },
                { key: 'cpmt', label: 'CPMT' },
                { key: 'esmr', label: 'ESMR' },
                { key: 'fard', label: 'FARD' },
                { key: 'cton', label: 'CTON' },
                { key: 'mufl', label: 'MUFL' },
                { key: 'prar', label: 'PRAR' },
                { key: 'sbag', label: 'SBAG' },
              ].map((item) => (
                <div key={item.key}>
                  <Form.Check
                    isValid
                    type="checkbox"
                    label={item.label}
                    checked={checkbox[item.key]}
                    onChange={(event) => handleCheckBoxdChange(item.key, event.target.checked)}
                  />
                </div>
              ))}

              {/* Separador visual */}
              <div style={{ width: '1px', backgroundColor: '#dee2e6', margin: '0 4px' }} />

              {/* Filtro: apenas equipamentos da cooperativa */}
              <div>
                <Form.Check
                  isValid
                  type="checkbox"
                  id="filter-only-coop-equipments"
                  label="Apenas da cooperativa"
                  checked={onlyCoopEquipments}
                  onChange={(e) => setOnlyCoopEquipments(e.target.checked)}
                  title="Exibe somente os equipamentos vinculados diretamente à cooperativa, sem os das unidades"
                />
              </div>
            </div>

            {equipments && equipments.length ? (
              <Equipments
                data={filterData()}
                onRemoveButton={removeEquipment}
                permission={permission}
                theme={theme}
              />
            ) : (
              <h5 className={`${theme === 'dark' ? 'text-light' : 'text-dark'}`}>Nenhum equipamento encontrado.</h5>
            )}
          </>
        </Tab>

        <Tab eventKey="unidades" title="UNIDADES">
          <>
            <SearchBar
              onSearch={handleSearchUnits}
              onSearchData={handleSearchData}
              searchData={searchData}
            />
            {unitsDetail && unitsDetail.length > 0 ? (
              <Cooperatives
                data={unitsDetail}
                onRemoveButton={removeUnit}
                permission={permission}
                theme={theme}
              />
            ) :
              <h5 className={`${theme === 'dark' ? 'text-light' : 'text-dark'}`}>Nenhuma unidade encontrada.</h5>
            }
          </>
        </Tab>

        {units && units?.dryer?.length > 0 && (
          <Tab eventKey="secadores" title="SECADORES">
            <>
              {/* <SearchBar
              onSearch={handleSearchUnits}
              onSearchData={handleSearchData}
              searchData={searchData}
            /> */}
              <DryersTable
                data={units.dryer}
                onRemoveButton={removeDryer}
                permission={permission}
                theme={theme}
              />
            </>
          </Tab>
        )}
      </Tabs>

      {/* Modal para selecionar modelos de equipamentos */}
      <Modal show={showModelSelectModal} onHide={() => setShowModelSelectModal(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>Selecionar modelos</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>Selecione os modelos de equipamentos que deseja alterar os dias de ativação:</p>
          <Form>
            {[...new Set(equipments.map(eq => eq.serialnumber.split('-')[0]))].map(model => (
              <Form.Check
                key={model}
                type="checkbox"
                label={model}
                checked={selectedModels.includes(model)}
                onChange={e => {
                  if (e.target.checked) {
                    setSelectedModels(prev => [...prev, model]);
                  } else {
                    setSelectedModels(prev => prev.filter(m => m !== model));
                  }
                }}
              />
            ))}
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowModelSelectModal(false)}>
            Cancelar
          </Button>
          <Button variant="success" onClick={() => {
            setShowModelSelectModal(false);
            setOpenDialogActivation(true);
          }} disabled={selectedModels.length === 0}>
            Avançar
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Modal de confirmação para aplicar alteração */}
      <Modal show={openDialogActivation} onHide={handleCloseUpdateActivation} centered>
        <Modal.Header closeButton>
          <Modal.Title>Alterar</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>
            Confirma alterar os dias de ativação dos equipamentos dos modelos selecionados ({selectedModels.join(', ')}) da{' '}
            <strong>{units.name}</strong>?
          </p>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseUpdateActivation}>
            Cancelar
          </Button>
          <Button variant="success" onClick={updateDaysActivation}>
            Salvar
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal show={openDialogPlanRental} onHide={handleCloseDialogPlan} centered>
        <Modal.Header closeButton>
          <Modal.Title>Alterar</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>
            Confirma alterar para o plano: <strong>{planRental}</strong> todos os equipamentos desta Cooperativa?
          </p>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseDialogPlan}>
            Cancelar
          </Button>
          <Button variant="success" onClick={handleUpdatePlanChangeRental}>
            Salvar
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal show={openDialogPlanOwner} onHide={handleCloseDialogPlan} centered>
        <Modal.Header closeButton>
          <Modal.Title>Alterar</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>
            Confirma alterar para o plano: <strong>{planOwner}</strong> todos os equipamentos desta Cooperativa?
          </p>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseDialogPlan}>
            Cancelar
          </Button>
          <Button variant="success" onClick={handleUpdatePlanChangeOwner}>
            Salvar
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal show={showBatchModal} onHide={handleCancelBatchAction} centered>
        <Modal.Header closeButton>
          <Modal.Title>Confirmação de Ação em Lote</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>
            Você está prestes a {batchAction.label} para todos os equipamentos selecionados.
            Deseja continuar?
          </p>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCancelBatchAction}>
            Cancelar
          </Button>
          <Button
            variant="success"
            onClick={() => {
              handleConfirmBatchAction();
              handleBatchActionRequest(batchAction.field, !batchAction.value, batchAction.label);
            }}
          >
            Confirmar
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Modal de confirmação para ações em lote */}
      <Modal show={showBatchModal} onHide={handleCancelBatchAction} centered>
        <Modal.Header closeButton>
          <Modal.Title>Confirmar Ação em Lote</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>
            <strong>{batchAction.label}</strong>
          </p>
          <p>
            Esta ação será aplicada a <strong>todos os equipamentos</strong> da cooperativa <strong>{units.name}</strong>.
          </p>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCancelBatchAction}>
            Cancelar
          </Button>
          <Button
            variant={batchAction.value ? "success" : "danger"}
            onClick={handleConfirmBatchAction}
          >
            {batchAction.value ? "✅ Confirmar Ativação" : "❌ Confirmar Desativação"}
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Modal de confirmação de unidades a serem adicionadas */}
      <Modal
        show={showUnitsConfirmModal}
        onHide={() => setShowUnitsConfirmModal(false)}
        centered
        contentClassName={theme === 'dark' ? 'bg-dark text-light' : ''}
      >
        <Modal.Header
          closeButton
          closeVariant={theme === 'dark' ? 'white' : undefined}
          className={theme === 'dark' ? 'bg-dark text-light border-secondary' : ''}
        >
          <Modal.Title>Confirmar Adição de Unidades</Modal.Title>
        </Modal.Header>
        <Modal.Body className={theme === 'dark' ? 'bg-dark text-light' : ''}>
          <p>As seguintes unidades serão adicionadas à cooperativa <strong>{units.name}</strong>:</p>
          {unitsToAdd.length > 0 ? (
            <div style={{ maxHeight: '300px', overflowY: 'auto' }}>
              {unitsToAdd.map((unitName, index) => (
                <div
                  key={index}
                  className="d-flex justify-content-between align-items-center mb-2 p-2"
                  style={{
                    border: theme === 'dark' ? '1px solid #495057' : '1px solid #dee2e6',
                    borderRadius: '4px',
                    backgroundColor: theme === 'dark' ? '#2b2b2b' : '#f8f9fa'
                  }}
                >
                  <span className={theme === 'dark' ? 'text-light' : 'text-dark'}>{unitName}</span>
                  <Button
                    variant="outline-danger"
                    size="sm"
                    onClick={() => handleRemoveUnitFromList(unitName)}
                  >
                    Remover
                  </Button>
                </div>
              ))}
            </div>
          ) : (
            <p className={theme === 'dark' ? 'text-light' : 'text-dark'}>Nenhuma unidade selecionada.</p>
          )}
        </Modal.Body>
        <Modal.Footer className={theme === 'dark' ? 'bg-dark text-light border-secondary' : ''}>
          <Button
            variant={theme === 'dark' ? 'outline-light' : 'secondary'}
            onClick={() => setShowUnitsConfirmModal(false)}
          >
            Cancelar
          </Button>
          <Button
            variant="success"
            onClick={handleAddUnits}
            disabled={unitsToAdd.length === 0 || addingUnits}
          >
            {addingUnits ? 'Adicionando...' : 'Confirmar Adição'}
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal
        show={showUnitsConflictModal}
        onHide={() => setShowUnitsConflictModal(false)}
        centered
        contentClassName={theme === 'dark' ? 'bg-dark text-light' : ''}
      >
        <Modal.Header
          closeButton
          closeVariant={theme === 'dark' ? 'white' : undefined}
          className={theme === 'dark' ? 'bg-dark text-light border-secondary' : ''}
        >
          <Modal.Title>Unidades já vinculadas</Modal.Title>
        </Modal.Header>
        <Modal.Body className={theme === 'dark' ? 'bg-dark text-light' : ''}>
          <p>
            Não foi possível adicionar. As unidades abaixo já estão vinculadas a outra matriz:
          </p>
          <div style={{ maxHeight: '320px', overflowY: 'auto' }}>
            {unitsConflictList.map((conflict) => (
              <div
                key={conflict.unitId || conflict.unitName}
                className="mb-2 p-2"
                style={{
                  border: theme === 'dark' ? '1px solid #495057' : '1px solid #dee2e6',
                  borderRadius: '4px',
                  backgroundColor: theme === 'dark' ? '#343a40' : '#fff3cd',
                }}
              >
                <div className={`fw-semibold ${theme === 'dark' ? 'text-light' : 'text-dark'}`}>
                  {conflict.unitName}
                </div>
                <small className={theme === 'dark' ? 'text-light opacity-75' : 'text-muted'}>
                  {conflict.matrices?.length
                    ? `Unidade vinculada a matriz ${conflict.matrices.join(', ')}`
                    : 'Já vinculada a outra matriz'}
                </small>
              </div>
            ))}
          </div>
        </Modal.Body>
        <Modal.Footer className={theme === 'dark' ? 'bg-dark text-light border-secondary' : ''}>
          <Button
            variant={theme === 'dark' ? 'outline-light' : 'secondary'}
            onClick={() => setShowUnitsConflictModal(false)}
          >
            Fechar
          </Button>
        </Modal.Footer>
      </Modal>

    </Page>
  );
};

export default CooperativesDetail;
